import type { ChangeEvent } from 'react';
import type { OAuthProviderType } from '@/context/LoginContext';
import type { AppSettings } from '@/utils/data/fetch-app-settings';

export interface LoginFormProps {
	buttonText?: string;
	checkboxText?: JSX.Element | string;
	className?: string;
	descriptionDefault?: string;
	descriptionError?: string;
	descriptionLoading?: string;
	descriptionSuccess?: string;
	handleOAuthSignIn?: (social: OAuthProviderType, location?: string) => void;
	location?: string;
	onContinue?: (email: string) => void;
	onEmailChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	onPasswordLoginContinue?: (email: string, password: string) => void;
	onPasswordResetContinue?: (email: string) => void;
	settings: AppSettings['settings'];
	siteName?: string;
	status?: LoginFormStatus;
	textFieldPlaceholder?: string;
	titleDefault?: string;
	titleError?: string;
	titleLoading?: string;
	titleSuccess?: string;
}

export enum LoginFormStatus {
	ERROR = 'error',
	IDLE = 'idle',
	LOADING = 'loading',
	SUCCESS = 'success',
}
